;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';
import { MdOutlineLocationOn, MdOutlineCall, MdMailOutline } from 'react-icons/md';
import slugify from 'slugify';
import LinkButton from './buttons/LinkButton';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import Card from './Card';
import { Agency } from 'shared/pages/Agencies';
import { getAgencyDisplayTitle } from 'shared/utils/agencyBranding';

type Props = {
  agency: Agency;
  dictionary: any;
  locale: string;
  className?: string;
  prependBrandName?: boolean;
};

export default function AgencyTeaser({ agency, dictionary, locale, className, prependBrandName = false }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const contactUrl = `/${locale}/contact/${agency.id || agency._id}/${slugify(agency.title as string)}`;
  const displayTitle = getAgencyDisplayTitle({ title: agency.title, prependBrandName });

  return (
    <Card className={`border mb-4 ${className}`} justify="start" smallPadding>
      <Link className="text-decoration-none" href={contactUrl}>
        <h2>{displayTitle}</h2>
      </Link>
      <div className="flex-fill d-flex flex-column gap-2">
        <span className="d-flex align-items-start gap-2">
          <MdOutlineLocationOn color="#6c757d" size="20" />
          <a
            className="text-decoration-none text-base"
            href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`Synergie,${agency.address1},${agency.address2 ? `${agency.address2}` : ''}${agency.postalCode},${agency.city}`)}`}
            target="_blank"
            rel="noreferrer noopener"
          >
            <address className="m-0">
              {agency.address1}
              <br />
              {agency.address2 ? <span>{agency.address2}</span> : null}
              {`${agency.postalCode} ${agency.city}`}
            </address>
          </a>
        </span>
        <span className="d-flex align-items-center gap-2">
          <MdOutlineCall color="#6c757d" size="20" />
          <a className="text-decoration-none text-base" href={`tel:${agency.telephone}`}>
            {agency.telephone}
          </a>
        </span>
        <span className="d-flex align-items-center gap-2">
          <MdMailOutline color="#6c757d" size="20" />{' '}
          <a className="text-decoration-none text-base" href={`mailto:${agency.email}`}>
            {agency.email}
          </a>
        </span>
      </div>
      <LinkButton type="outlineRed" href={contactUrl}>
        {formatMessage({ id: 'agency-teaser-read-more' })}
      </LinkButton>
    </Card>
  );
}
